import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { ConfigService } from '../../../../core/config.service';
import { Distribution, DistributionOverviewItem, RequestResult } from '../../models';
import { BaseRestApiService } from '../base/base-rest.api.service';
import { LogService } from '../logging/log.service';
import { StopDistributionReasonDto } from '../../models/stop-distribution-reason-dto';
import { ReasonDto } from '../../models/distribution/reasonDto';
import { TrackingData } from '../../models/tracking/tracking_data';

@Injectable()
export class DistributionApiService extends BaseRestApiService {

    constructor(http: HttpClient, logService: LogService, private configService: ConfigService) {
        super(http, logService);
    }

    public getDistributionDetailById(distributionId: string): Observable<Distribution> {
        const API_URL: string = this.configService.getEnv('distributionApi');
        return this.get(`${API_URL}/detail/${distributionId}`)
            .map((response: RequestResult<Distribution>) => {
                return new Distribution(response.data);
            })
            .catch((error: Response | any) => Observable.throw(error));
    }

    public getTrackingData(distributionId: string): Observable<TrackingData> {
        const API_URL: string = this.configService.getEnv('distributionApi');
        return this.get(`${API_URL}/processed/${distributionId}`)
            .map((response: RequestResult<TrackingData>) => {
                return response.data;
            })
            .catch((error: Response | any) => Observable.throw(error));
    }

    public getDistributionOverviewByWeekNumber(weekNumber: number): Observable<DistributionOverviewItem[]> {
        const API_URL: string = this.configService.getEnv('distributionApi');
        return this.get(`${API_URL}/overview/${weekNumber}`)
            .map((response: RequestResult<any>) =>
                response.data.map((distributionOverviewItem: DistributionOverviewItem) => new DistributionOverviewItem(distributionOverviewItem)))
            .catch((error: Response | any) => Observable.throw(error));
    }

    public startDistribution(distributionId: string): Observable<any> {
        const API_URL: string = this.configService.getEnv('distributionApi');
        return this.post(`${API_URL}/${distributionId}/startDistribution`)
            .map((response: RequestResult<any>) => response.data)
            .catch((error: Response | any) => Observable.throw(error));
    }

    public stopDistribution(stopDistributionReasonDto: StopDistributionReasonDto): Observable<any> {
        const API_URL: string = this.configService.getEnv('distributionApi');
        return this.post(`${API_URL}/${stopDistributionReasonDto.distributionId}/stopDistribution`, new ReasonDto(stopDistributionReasonDto.reasonToStop))
            .map((response: RequestResult<any>) => response.data)
            .catch((error: Response | any) => Observable.throw(error));
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/services/distribution/distribution.api.service.ts